import { render, staticRenderFns } from "./editRobika.vue?vue&type=template&id=3f17c97d&scoped=true"
import script from "./editRobika.vue?vue&type=script&lang=js"
export * from "./editRobika.vue?vue&type=script&lang=js"
import style0 from "./editRobika.vue?vue&type=style&index=0&id=3f17c97d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17c97d",
  null
  
)

export default component.exports